import styled from "@emotion/styled";
import { Icon, Paper, Theme, Typography } from "@yuno/design-system-web";

const Frame = styled(Paper)<{ theme?: Theme }>`
  position: relative;
  width: 802px;
  height: 720px;
  border-top-radius: 8px;
  position: relative;
  background: ${({ theme }) => theme.palette.grey[0]};
`;

const UrlBar = styled.div<{ theme?: Theme }>`
  background: ${({ theme }) => theme.palette.neutral.white[0]};
  display: flex;
  align-items: center;
  padding: 7px 20px 7px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[2]};
  gap: 165px;
`;
const Circles = styled.div<{ theme?: Theme }>`
  display: flex;
  gap: 10px;
  color: ${({ theme }) => theme.palette.grey[3]};
`;

const Bar = styled.div<{ theme?: Theme }>`
  width: 355px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  background: red;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.grey[1]};
  & p {
    font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
    color: ${({ theme }) => theme.palette.grey[4]};
  }
`;

export const BrowserFrame = ({ children }) => {
  return (
    <Frame>
      <UrlBar>
        <Circles>
          <Icon name="Circle" weight="fill" size="6px" />
          <Icon name="Circle" weight="fill" size="6px" />
          <Icon name="Circle" weight="fill" size="6px" />
        </Circles>

        <Bar>
          <Typography>https://y.uno/checkout/merchant</Typography>
        </Bar>
      </UrlBar>
      {children}
    </Frame>
  );
};
